import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { InputField, IntegerField } from '../../form/field';
import { HorizontalLayout } from '../../form/layout';
import OwnerField from '../field/Owner';

const ForeignIncomes = ({ name, ripFromRecommendation }) => (
    <Fragment>
        <HorizontalLayout>
            <IntegerField name={`${name}.income`} title="Montant annuel" required />
            <InputField name={`${name}.recurring`} title="Récurrent" type="checkbox" />
            <OwnerField name={`${name}.beneficiary`} title="Bénéficiaire(s)" ripFromRecommendation={ripFromRecommendation} required />
        </HorizontalLayout>
    </Fragment>
);

ForeignIncomes.propTypes = {
    name: PropTypes.string.isRequired,
    ripFromRecommendation: PropTypes.shape({}),
};

export default ForeignIncomes;
